// Plan helpers — see CLAUDE.md's "Plans" section.
// Free: unlimited core tracking (expenses, subscriptions, budgets, transactions, calendar).
// Pro ($9.99/mo): everything in Free + Analytics, Sinking Funds, Investments.
// Family ($15.99/mo): everything in Pro + household/family sharing.
// No real payment processor is wired up — plan is set directly via POST /billing/upgrade.

export const PLANS = {
    free: { label: "Free", price: 0 },
    pro: { label: "Pro", price: 9.99 },
    family: { label: "Family", price: 15.99 },
};

// Household members inherit the owner's plan rather than carrying their own paid plan —
// mirrors the backend's _effective_plan() in server.py. Use this wherever a Pro-and-up
// feature (Analytics, Sinking Funds, Investments) is gated in the UI. Always pass
// `isMember` from useHousehold() — a bare `user.plan` check misses inherited access.
export function hasProAccess(user, isMember) {
    return user?.plan === "pro" || user?.plan === "family" || !!isMember;
}

// Family-plan-gated features (creating a household) must check the user's own literal
// plan, not inherited access — an inherited-Pro/Family member shouldn't be able to spin
// up a second household for free. In practice this branch is unreachable for existing
// members anyway, since they see the household member view instead.
export function hasFamilyPlan(user) {
    return user?.plan === "family";
}
